import getObjectKey from 'lib/object/getObjectKey'

function getLoyaltyPointBurnCalculationKey(
  requests: Array<App.Checkout.LoyaltyPointBurnCalculationRequest>,
): string {
  return getObjectKey(requests.map(({ item, ...rest }) => ({
    ...rest,
    // Don't need to stringify the massive checkout item object!
    // The `itemId` should be reliable.
    itemId: item.itemId,
  })))
}

export default getLoyaltyPointBurnCalculationKey
